<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 补货计划 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="查询维度">
          <el-button-group>
            <el-button
              @click="onTypeClick('storehouse')"
              :type="typeName == 'storehouse' ? 'primary' : 'default'"
            >
              中心仓
            </el-button>
            <el-button
              @click="onTypeClick('store')"
              :type="typeName == 'store' ? 'primary' : 'default'"
            >
              门店
            </el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item label="中心仓" v-if="typeName == 'storehouse'">
          <customer-storehouse-select
            :defaultFirst="true"
            style="width: 240px"
            v-model="storehouseGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="仓库门店" v-if="typeName == 'store'">
          <customer-store-select
            :defaultFirst="true"
            style="width: 180px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="展示类型" v-if="typeName == 'storehouse'">
          <el-button-group>
            <el-button
              @click="onActiveClick('arranged')"
              :type="activeName == 'arranged' ? 'primary' : 'default'"
            >
              补货计划
            </el-button>
            <el-button
              @click="onActiveClick('purchase')"
              :type="activeName == 'purchase' ? 'primary' : 'default'"
            >
              全部采购单
            </el-button>
          </el-button-group>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div style="padding: 10px" v-if="!!storehouseGuid || !!storeGuid">
        <template v-if="!refresAble">
          <template v-if="typeName == 'storehouse' && !!storehouseGuid">
            <arranged-by-store v-if="activeName == 'arranged'" :query="defaultParams" />
            <arranged-purchase-list
              v-else-if="activeName == 'purchase'"
              :query="defaultParams"
            />
          </template>
          <template v-if="typeName == 'store' && !!storeGuid">
            <arranged-purchase-list :query="defaultParams" :hiddenStore="true" />
          </template>
        </template>
      </div>
      <el-empty v-else description="请选择中心仓库或门店" :image-size="100" />
    </el-card>
  </div>
</template>

<script>
import customerStorehouseSelect from "../../../../components/business/customerStorehouseSelect.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import arrangedByStore from "./__inner_arranged_list_store.vue";
import arrangedPurchaseList from "./__arranged_purchase_list.vue";

export default {
  components: {
    arrangedByStore,
    customerStorehouseSelect,
    customerStoreSelect,
    arrangedPurchaseList,
  },
  props: {
    tabName: {
      type: String,
    },
    tabProps: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      if (this.typeName == "store") {
        return Object.assign(
          {
            storeGuid: this.storeGuid,
          },
          this.queryModel
        );
      }
      return Object.assign(
        {
          storehouseGuid: this.storehouseGuid,
        },
        this.queryModel
      );
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    refresh() {
      this.refresAble = true;
      this.$nextTick(() => {
        this.refresAble = false;
      });
    },
    onTypeClick(mode) {
      this.typeName = mode;
    },
    onActiveClick(mode) {
      this.activeName = mode;
    },
    clearClick() {
      this.formInline = {
        optStatus: "",
        queryValue: "",
      };
      this.queryModel = {
        optStatus: "",
        queryValue: "",
      };
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
  },
  watch: {
    storehouseGuid() {
      this.commitState({ curStorehouseGuid: this.storehouseGuid });
    },
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
    },
  },
  data() {
    return {
      refresAble: false,
      storehouseGuid: "",
      storeGuid: "",
      typeName: "storehouse",
      activeName: "arranged",
      queryModel: {
        optStatus: "",
        queryValue: "",
      },
      formInline: {
        optStatus: "",
        queryValue: "",
      },
    };
  },
  mounted() {
    this.storehouseGuid = this.readState("curStorehouseGuid", "");
    this.storeGuid = this.readState("curStoreGuid", "");
  },
};
</script>
